import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';

import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@mui/material';

export type ModalNotificationProps = ComponentPropsWithoutRef<typeof Dialog> & {
  open: boolean;
  onClose?: () => void;
  dialogProps: {
    title: string | ReactNode;
    titleProps?: Omit<ComponentPropsWithoutRef<typeof DialogTitle>, 'children'>;
    content: ReactNode;
    actions: (ButtonProps & {
      label: string;
      renderComponent?: ReactNode;
      icon?: ReactNode;
    })[];
  };
  size?: DialogProps['maxWidth'];
};

const ModalNotification: FC<ModalNotificationProps> = ({
  open,
  onClose,
  dialogProps,
  size = 'xs',
  ...restProps
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={size} {...restProps}>
      <DialogTitle {...dialogProps.titleProps}>{dialogProps.title}</DialogTitle>
      <DialogContent>{dialogProps.content}</DialogContent>
      <DialogActions sx={{ pb: 2, px: 3 }}>
        {dialogProps.actions.map((action) => {
          const { renderComponent, ...restProps } = action;

          return (
            <Button
              key={action.label}
              color={action.color}
              variant={action.variant}
              onClick={action.onClick}
              {...restProps}
            >
              {action.icon}
              {renderComponent || action.label}
            </Button>
          );
        })}
      </DialogActions>
    </Dialog>
  );
};

export default ModalNotification;
